// @flow
import * as React from 'react';
import { getAddressString } from 'utils/address';
import { H4, Body } from 'components/Text';

const Address = ({ address }: { address: Object }) => (
  <>
    {address.description && <H4 mb={0}>{address.description}</H4>}
    <Body>{getAddressString(address)}</Body>
  </>
);

export default Address;
